export default __webpack_public_path__ + "static/media/5282.de0ab10d.png";